import React from 'react';
import logo from '../../images/logo.svg';

const NotFound = () => {

  return (
    <section className="landing">
        <div className="landing-inner">
          <h1 className="x-large">
            <img className = "dtulogo" src={logo} alt="logo"/>
          </h1>
          <h1 className="x-large">404</h1>
          <p className="lead">
            Page not found!
          </p>
        </div>
    </section>
  )
};

export default NotFound;